import React, { useEffect, useState } from 'react'
import { Meeting, MeetingParticipant } from '../../modules/meeting/model'
import { Button } from '../../onsaui'
import { meetingApi } from '../../modules/meeting/api'
import { IllustrationSpace, IllustrationWelcome } from '../../onsaui/icons'
import MeetingInfoPage from './MeetingInfoPage'
import { formatTime } from '../../shared/helpers/time'

const MyMeetingsPage: React.FC = () => {
  const [meetings, setMeetings] = useState<Meeting[]>([])
  const [selectedMeeting, setSelectedMeeting] = useState<Meeting | null>(null)
  const [loadingMeetings, setLoadingMeetings] = useState(true)

  const fetchUserMeetings = async () => {
    try {
      // Replace with your real API call or hook
      const userMeetings = await meetingApi.getMeetings()
      setMeetings(userMeetings)
      setLoadingMeetings(false)
    } catch (error) {
      console.error('Failed to fetch user meetings:', error)
    }
  }

  useEffect(() => {
    fetchUserMeetings()
  }, [])

  // If a meeting is selected, show details
  if (selectedMeeting) {
    return (
      <MeetingInfoPage
        selectedMeeting={selectedMeeting}
        setSelectedMeeting={setSelectedMeeting}
        reloadMeetings={fetchUserMeetings}
      />
    )
  }

  if (!meetings.length && !loadingMeetings) {
    return (
      <div className="p-4">
        <h1 className="mb-4 text-2xl font-bold">My Meetings</h1>
        <div className="mt-8 flex flex-col items-center justify-center">
          <IllustrationSpace className="mb-4 h-32 w-32" />
          <p className="text-center text-lg text-gray-600">
            No meetings found - maybe it's worth to try one!
          </p>
        </div>
      </div>
    )
  }

  return (
    <div className="p-4">
      <h1 className="mb-4 text-2xl font-bold">My Meetings</h1>
      <div className="flex flex-col gap-4">
        {meetings.map((meeting) => (
          <div
            key={meeting.id}
            className="flex items-center justify-between rounded-md bg-gray-100 p-4"
          >
            <div>
              <p className="font-semibold">{meeting.metadata?.title || 'Untitled Meeting'}</p>
              <p className="text-sm text-gray-600">
                {`Start Time: ${formatTime(meeting.startTime)}`}
              </p>
              <p className="mt-2 text-sm text-gray-600">{`Zoom Meeting ID: ${meeting.zoomId}`}</p>
              {/* Bot status */}
              <p className="mt-1 text-xs text-gray-500">Bot Status: {meeting.botStatus.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase())}</p>
              {meeting.summary && (
                <p className="mt-2 text-sm text-blue-700">Summary: {meeting.summary}</p>
              )}
              {Array.isArray(meeting.participants) && meeting.participants.length > 0 && (
                <p className="mt-2 text-sm text-gray-700">
                  Participants: {meeting.participants.map((p) => p.screenName || 'Unknown').join(', ')}
                </p>
              )}
            </div>
            <div className="flex items-center gap-4">
              <div className="flex items-center text-sm text-gray-700">
                <IllustrationWelcome className="mr-1 h-4 w-4" />
                {meeting.participants?.length || 0}
              </div>
              <Button onClick={() => setSelectedMeeting(meeting)}>More Info</Button>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default MyMeetingsPage
